export const comics = [
  {
    id: 1,
    title: '社内相亲',
    author: 'HAE Min',
    category: 'love',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20romance%20office%20couple%20illustration%2C%20clean%20style%2C%20two%20characters%20facing%20each%20other%2C%20soft%20warm%20lighting%2C%20simple%20cream%20background%2C%20elegant%20digital%20art%2C%20Korean%20comic%20style%2C%20minimal%20composition&width=600&height=800&seq=hanman-comic-01&orientation=portrait',
    rating: 9.7,
    popularity: '15.8亿',
    status: 'completed',
    statusText: '已完结',
    description: '普通职员申夏莉代替朋友去相亲，本想吓跑对方，却发现相亲对象竟是公司社长姜泰武。一场充满误会与甜蜜的办公室恋爱故事就此展开。精致的画风与细腻的情感描写，让这部作品成为韩漫恋爱类的标杆之作。',
    latestChapter: '第120话 完结',
    updateDate: '2025-12-15',
    chapters: 120,
    tags: ['恋爱', '办公室', '总裁', '契约恋爱'],
  },
  {
    id: 2,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: 'fantasy',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20hunter%20with%20dark%20armor%20illustration%2C%20dramatic%20lighting%2C%20purple%20energy%20effect%2C%20clean%20style%2C%20simple%20dark%20background%2C%20powerful%20character%20pose%2C%20digital%20art%2C%20Korean%20comic%20style&width=600&height=800&seq=hanman-comic-02&orientation=portrait',
    rating: 9.9,
    popularity: '32.1亿',
    status: 'completed',
    statusText: '已完结',
    description: '在被称为「人类最弱兵器」的E级猎人成振宇，在一次地下城探险中濒死之际获得了神秘系统的力量，成为唯一能够「升级」的猎人。从最弱到最强，他独自踏上了逆天改命的征途。',
    latestChapter: '第179话 完结',
    updateDate: '2026-01-20',
    chapters: 179,
    tags: ['奇幻', '动作', '升级', '热血'],
  },
  {
    id: 3,
    title: '女神降临',
    author: 'Yaongyi',
    category: 'love',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20beauty%20school%20romance%20female%20character%20with%20makeup%20illustration%2C%20clean%20style%2C%20soft%20pastel%20tone%2C%20simple%20cream%20background%2C%20Korean%20comic%20art%2C%20elegant%20female%20portrait%2C%20minimal%20composition&width=600&height=800&seq=hanman-comic-03&orientation=portrait',
    rating: 9.5,
    popularity: '28.3亿',
    status: 'completed',
    statusText: '已完结',
    description: '因外貌被欺负的女孩任朱静，通过化妆技术摇身一变成为校园女神。她周旋于两位校草之间，在真实自我与完美形象之间挣扎，引发无数读者的共鸣与讨论。',
    latestChapter: '第225话 完结',
    updateDate: '2025-10-08',
    chapters: 225,
    tags: ['恋爱', '校园', '美容', '三角恋'],
  },
  {
    id: 4,
    title: '秘密教学',
    author: 'BAEKKYUNG',
    category: 'love',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20secret%20relationship%20illustration%2C%20clean%20style%2C%20warm%20moody%20lighting%2C%20simple%20beige%20background%2C%20two%20characters%20close%20together%2C%20Korean%20comic%20art%2C%20emotional%20atmosphere&width=600&height=800&seq=hanman-comic-04&orientation=portrait',
    rating: 9.3,
    popularity: '19.7亿',
    status: 'ongoing',
    statusText: '连载中',
    description: '家境贫寒的大学生为了赚取学费，成为了富家千金的私人家教。然而这段看似简单的教学关系，却逐渐演变成了一段不可告人的秘密恋情。',
    latestChapter: '第98话',
    updateDate: '2026-06-28',
    chapters: 98,
    tags: ['恋爱', '师生', '秘密', '都市'],
  },
  {
    id: 5,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: 'fantasy',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalypse%20fantasy%20survival%20illustration%2C%20male%20character%20with%20book%2C%20dramatic%20lighting%2C%20clean%20style%2C%20simple%20dark%20background%2C%20mysterious%20atmosphere%2C%20Korean%20comic%20art%2C%20action%20pose&width=600&height=800&seq=hanman-comic-05&orientation=portrait',
    rating: 9.8,
    popularity: '25.6亿',
    status: 'ongoing',
    statusText: '连载中',
    description: '金独子是唯一读完一部长达3149话网络小说的人。当小说中的末日场景在现实成真时，他凭借对剧情的了解，在这个崩塌的世界中寻找生存之道。',
    latestChapter: '第210话',
    updateDate: '2026-07-01',
    chapters: 210,
    tags: ['奇幻', '末世', '生存', '智慧'],
  },
  {
    id: 6,
    title: '炸鸡特攻队',
    author: 'Baek Kyung-Tae',
    category: 'comedy',
    categoryName: '喜剧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20food%20fried%20chicken%20restaurant%20illustration%2C%20fun%20style%2C%20warm%20yellow%20lighting%2C%20simple%20cream%20background%2C%20characters%20eating%20together%2C%20Korean%20comic%20art%2C%20cheerful%20atmosphere&width=600&height=800&seq=hanman-comic-06&orientation=portrait',
    rating: 9.1,
    popularity: '12.4亿',
    status: 'completed',
    statusText: '已完结',
    description: '五位性格各异的炸鸡店员工，在经营炸鸡店的日常中发生的一系列爆笑故事。他们用炸鸡征服顾客的胃，用友情温暖彼此的心。轻松幽默又不失温情的治愈系喜剧。',
    latestChapter: '第88话 完结',
    updateDate: '2025-08-30',
    chapters: 88,
    tags: ['喜剧', '美食', '日常', '治愈'],
  },
  {
    id: 7,
    title: '再婚皇后',
    author: 'Alpha Tart',
    category: 'love',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20queen%20in%20elegant%20dress%20illustration%2C%20clean%20style%2C%20royal%20palace%20vibe%2C%20warm%20golden%20lighting%2C%20simple%20cream%20background%2C%20Korean%20comic%20art%2C%20regal%20female%20portrait&width=600&height=800&seq=hanman-comic-07&orientation=portrait',
    rating: 9.6,
    popularity: '22.1亿',
    status: 'ongoing',
    statusText: '连载中',
    description: '帝国的皇后娜维尔在丈夫公开宣布废后另立新欢后，毅然提出离婚。但她的条件令所有人震惊——她要与邻国的国王再婚，成为更加强大的皇后。',
    latestChapter: '第156话',
    updateDate: '2026-06-25',
    chapters: 156,
    tags: ['恋爱', '宫廷', '逆袭', '历史'],
  },
  {
    id: 8,
    title: '甜蜜家园',
    author: 'Kim Carnby / Hwang Young-Chan',
    category: 'thriller',
    categoryName: '惊悚',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20thriller%20monster%20apartment%20illustration%2C%20dark%20moody%20style%2C%20dim%20lighting%2C%20simple%20dark%20background%2C%20tense%20atmosphere%2C%20Korean%20comic%20art%2C%20survival%20theme&width=600&height=800&seq=hanman-comic-08&orientation=portrait',
    rating: 9.4,
    popularity: '18.9亿',
    status: 'completed',
    statusText: '已完结',
    description: '在怪物肆虐的末世中，一栋公寓楼的居民们必须团结起来求生。人性的黑暗与光辉在绝境中被无限放大，每个人都要面对内心深处的怪物。改编Netflix大热剧集。',
    latestChapter: '第140话 完结',
    updateDate: '2025-05-12',
    chapters: 140,
    tags: ['惊悚', '末世', '怪物', '人性'],
  },
  {
    id: 9,
    title: '反派千金的生存法则',
    author: 'Haeyoon / PingPu',
    category: 'fantasy',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20villainess%20noble%20lady%20illustration%2C%20clean%20style%2C%20elegant%20dress%2C%20soft%20warm%20lighting%2C%20simple%20cream%20background%2C%20Korean%20comic%20art%2C%20confident%20female%20character&width=600&height=800&seq=hanman-comic-09&orientation=portrait',
    rating: 9.2,
    popularity: '14.3亿',
    status: 'ongoing',
    statusText: '连载中',
    description: '穿越成小说中注定死亡的反派千金，她决定改写自己的命运。不再做那个愚蠢的恶役，而是用自己的智慧与魅力，在这个贵族社会中开辟出一条生路。',
    latestChapter: '第87话',
    updateDate: '2026-06-30',
    chapters: 87,
    tags: ['奇幻', '穿越', '贵族', '逆袭'],
  },
  {
    id: 10,
    title: '外貌至上主义',
    author: 'Park Tae-Jun',
    category: 'action',
    categoryName: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20school%20fight%20male%20character%20illustration%2C%20clean%20style%2C%20dynamic%20pose%2C%20simple%20dark%20background%2C%20strong%20lighting%20contrast%2C%20Korean%20comic%20art%2C%20intense%20atmosphere&width=600&height=800&seq=hanman-comic-10&orientation=portrait',
    rating: 9.0,
    popularity: '20.5亿',
    status: 'ongoing',
    statusText: '连载中',
    description: '一个因为外貌被霸凌的胖男孩，意外获得了完美的身体。白天是校园男神，夜晚回归真身。在两个身份之间切换的他，用拳头和正义感对抗校园暴力。',
    latestChapter: '第198话',
    updateDate: '2026-07-02',
    chapters: 198,
    tags: ['动作', '校园', '变身', '热血'],
  },
];

export const categories = [
  { id: 'love', slug: 'love', name: '恋爱', icon: 'ri-heart-line', count: 1280, description: '甜蜜浪漫的爱情故事' },
  { id: 'fantasy', slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 960, description: '穿越异世界的奇幻冒险' },
  { id: 'action', slug: 'action', name: '动作', icon: 'ri-sword-line', count: 750, description: '热血沸腾的战斗场面' },
  { id: 'comedy', slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', count: 620, description: '轻松愉快的搞笑日常' },
  { id: 'thriller', slug: 'thriller', name: '惊悚', icon: 'ri-ghost-line', count: 430, description: '紧张刺激的悬疑故事' },
  { id: 'daily', slug: 'daily', name: '日常', icon: 'ri-sun-line', count: 540, description: '温暖治愈的生活点滴' },
];

export const reviews = [
  {
    id: 1,
    name: '漫画迷小陈',
    level: 'VIP会员 · 阅读时长3800小时',
    content: '韩漫大全是我用过最好的韩漫阅读平台！画质清晰，更新速度快，分类也很全。从恋爱到奇幻，各种类型应有尽有。最让我感动的是完全免费，阅读体验却一点不输付费平台。推荐给了身边所有喜欢韩漫的朋友！',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20reading%20comic%20on%20tablet%20in%20cozy%20cafe%2C%20warm%20lighting%2C%20soft%20focus%2C%20casual%20style%2C%20simple%20cream%20background%2C%20relaxed%20atmosphere%2C%20editorial%20photography&width=400&height=600&seq=hanman-review-01&orientation=portrait',
  },
  {
    id: 2,
    name: '小王子殿下',
    level: 'VIP会员 · 阅读时长2100小时',
    content: '作为一个资深韩漫读者，我几乎尝试过市面上所有的韩漫平台。最终选择了韩漫大全，因为这里的导航真的太方便了！韩漫网址简洁好记，分类清晰，找漫画从不超过三步。每天更新的推荐列表让我发现了超多冷门好作品。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20sitting%20on%20sofa%20reading%20webtoon%20on%20phone%2C%20warm%20indoor%20lighting%2C%20casual%20vibe%2C%20simple%20cream%20background%2C%20relaxed%20pose%2C%20editorial%20photography&width=400&height=600&seq=hanman-review-02&orientation=portrait',
  },
];

export const siteInfo = {
  name: '韩漫大全',
  slogan: '韩国漫画免费阅读第一站',
  description: '韩漫大全致力于为中文读者提供最新、最全、最优质的韩国漫画免费阅读服务。我们收录了超过5000部韩漫作品，涵盖恋爱、奇幻、动作、喜剧、惊悚、日常等多种类型，每日更新，永久免费。',
  email: 'hello@wiiohv.cn',
  phone: '400-888-6666',
  address: '北京市朝阳区望京科技园A座1208室',
  established: '2019',
  totalComics: '5000+',
  dailyReaders: '120万+',
  dailyUpdates: '80+',
  partnerCount: '35+',
};

export const faqs = [
  {
    question: '韩漫大全是否需要付费？',
    answer: '完全不需要！韩漫大全始终坚持免费阅读的理念，所有漫画作品均可免费畅读，无任何隐藏收费项目。我们依靠广告收入维持运营，承诺永久对读者免费开放。',
  },
  {
    question: '网站上的漫画更新频率如何？',
    answer: '我们每日更新超过80部热门韩漫作品，确保读者能够第一时间阅读到最新章节。热门连载作品通常会在韩国发布后24小时内完成中文翻译并上线。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航、搜索功能来查找漫画。我们提供了恋爱、奇幻、动作、喜剧、惊悚、日常六大分类，每个分类下都有精选推荐。如果您记得漫画名称，直接在韩漫网址使用搜索功能即可。',
  },
  {
    question: '支持在手机上阅读吗？',
    answer: '当然支持！韩漫大全采用响应式设计，完美适配手机、平板和电脑。无论您使用什么设备，都能获得流畅舒适的阅读体验。我们还特别优化了移动端的竖向阅读模式，更符合韩漫的阅读习惯。',
  },
  {
    question: '漫画的画质如何？',
    answer: '我们提供高清画质，所有漫画均以最佳分辨率呈现。色彩还原精准，细节清晰可见，力求为您呈现与韩国原版一致的视觉体验。',
  },
];
